<template>

  <router-view />

</template>

<script>
import '@/css/baro-tokens.css';
import '@/css/App.css';
import '@/css/sweetalert.css';
import { isPhone } from '@/utils/device';
export default {

  data () {
    return {
      
        unauth:null
      , untoken:null
      , unuserinfo:null

    }
  },

  created(){

    //세션 초기화 이벤트 수신
    this.$emitter.on('clearsession', this.clearsession);

    //이건 사용 안해도 되자나?
    this.unauth = this.$fireauth.onAuthStateChanged(async (user) => {
      //console.log("onAuthStateChanged time : " + new Date());
      if(user){
        //console.log("onAuthStateChanged user : " + JSON.stringify(user));
      }
    });    

    //id토큰이 갱신되면 호출됨. 저장해야함.
    //로그인시, 회원가입시, 토큰갱신시, 새로고침시
    this.untoken = this.$fireauth.onIdTokenChanged(async (user)=>{

      if(user){

        const idTokenResult = await user.getIdTokenResult();  //claims값 보기 위해서 요청, true를 쓰면 절대 안됨.
        
        //console.log("idTokenResult : " + JSON.stringify(idTokenResult.claims));

        //이메일 인증처리 체크
        if(!idTokenResult.claims.email_verified){
          this.$swal("인증메일을 확인해주세요.");
          return;
        }

        //사용자 동의 체크
        if(!idTokenResult.claims.AGREE || idTokenResult.claims.AGREE == 0){
          //사용자 동의가 안된경우 회원가입으로 유도해라.
          this.$router.push('/ServiceAgree');
          return;
        }

        //claims에 커스텀 토큰 생성시 넣은 claims와 firebase 자체 설정 claims가 같이 들어있음.
        this.$userStore.setUserData({
            LOCALID: user.uid
          , PARENT_LOCALID: idTokenResult.claims.PARENT_LOCALID
          , ACCNT: idTokenResult.claims.ACCNT
          , NAME: idTokenResult.claims.NAME
          , GRADE: idTokenResult.claims.GRADE
          , STATE: idTokenResult.claims.STATE
          , TIMEZONE: idTokenResult.claims.TIMEZONE
          , PRODUCT_NAME: idTokenResult.claims.PRODUCT_NAME
          , LIMIT_CONNECT: idTokenResult.claims.LIMIT_CONNECT
          , LIMIT_SIZE: idTokenResult.claims.LIMIT_SIZE
          , LIMIT_CONTENT: idTokenResult.claims.LIMIT_CONTENT
          , LIMIT_SCREEN: idTokenResult.claims.LIMIT_SCREEN
          , LIMIT_PAGE: idTokenResult.claims.LIMIT_PAGE
          , LIMIT_POPUP: idTokenResult.claims.LIMIT_POPUP
          , LIMIT_TTS: idTokenResult.claims.LIMIT_TTS
          , LIMIT_MONITOR: idTokenResult.claims.LIMIT_MONITOR
          , LIMIT_AI_TOKEN: idTokenResult.claims.LIMIT_AI_TOKEN
          , FIRETOKEN: idTokenResult.token
        });

        if(!this.$userStore.hasSearchID){
          //업체선택 값이 없으면 처음 셋팅
          this.$userStore.setUserData({
              SEARCH_LOCALID: user.uid
            , SEARCH_PARENT_LOCALID: idTokenResult.claims.PARENT_LOCALID
            , SEARCH_ACCNT_NAME: idTokenResult.claims.NAME
          });
        }else{
          //무언가 값이 있다면 토큰이 갱신된 케이스라서 기존 선택값을 건들지 말 것.
        }

        if(idTokenResult.claims.STATE == 0){
          //탈퇴한 회원
          this.$swal("탈퇴하여 사용할 수 없는 계정입니다.");
          this.$emitter.emit('clearsession');
          return;
        }

        //이동
        if(idTokenResult.claims.GRADE > 90){
          //로그인 성공 전역 이벤트 발송
          if(window.location.pathname == "/Home/BaroLogin" || window.location.pathname == "/SubLogin" || window.location.pathname == "/ServiceAgree"){
            this.$router.push('/Admin');
          }
          
        }else{
          if(window.location.pathname == "/Home/BaroLogin" || window.location.pathname == "/SubLogin" || window.location.pathname == "/ServiceAgree"){
            // 모바일 감지 및 분기처리 (태블릿은 PC로 취급)
            if(isPhone()){
              this.$router.push('/Mobile');
            }else{
              this.$router.push('/My');
            }
          }
          
        }

      }
    })    

  },

  beforeUnmount(){
    
    //console.log("beforeUnmount...");
    //window.removeEventListener('beforeunload', this.unloadevent);
    
    //세션 초기화 이벤트 해제
    this.$emitter.off('clearsession');

    //파이어베이스 리스너 해제
    if(this.unauth){
      this.unauth();
    }
    if(this.untoken){
      this.untoken();
    }
    if(this.unuserinfo){
      this.unuserinfo();
    }

  },
  
  mounted(){
    
    //console.log("app mount...1");

    //로딩바 숨기기
    document.getElementById('loading').style.display = 'none';
  },


  methods: {

    logout:function(){

        this.$swal({title:"로그아웃 하시겠습니까?", showCancelButton:true})
        .then(async (aresult) => {
          if(aresult.isConfirmed){
            this.logout2();
          }
        });

    },

    //화면이동 전역 이벤트 수신
    async clearsession(){
      this.logout2();
    },

    async logout2(){
      
      if(this.unuserinfo){
        this.unuserinfo();
      }
      
      this.$userStore.clearUserData();

      try{
        await this.$fireauth.signOut();
        this.$router.push("/");
      }catch(error){
        //console.log("firelogout : " + error);
      }
      
    },

    //페이지 새로고침 또는 주소창에 다른주소 입력해서 빠져나갈 때 경고
    unloadevent:function(event){
      event.preventDefault();
      event.returnValue = "";
    },


  },

}
</script>

<style>

.background_basic{
  min-height: 100vh;
}

/*페이지명*/
.menunamestyle{
  font-family: 'Inter';
  font-style: normal;
  font-weight: 600;    
  color: #000000;
}
/*전체 페이지 수*/
.total_label{
  color: #000000;
  font-weight: bold;
  font-size: 12px;
}

/* 데이터 테이블 정렬용 컬럼 헤더 스타일 */
.cheader_sortselect{
  font-family: 'Pretendard', 'Inter', sans-serif !important;
  font-style: normal !important;
  font-weight: 600 !important;
  font-size: 13px !important;
  color: #7C44F2 !important;
  text-decoration: none !important;
}

.cheader_sort{
  font-family: 'Pretendard', 'Inter', sans-serif !important;
  font-style: normal !important;
  font-weight: 600 !important;
  font-size: 13px !important;
  color: #475569 !important;
  text-decoration: none !important;
}

.cheader_normal{
  font-family: 'Inter' !important;
  font-style: normal !important;
  font-weight: 600 !important;
  font-size: 14px !important;
  color:#000000 !important;
  text-underline-position: auto;
  border-bottom: 2px red;
}

/* 사이드메뉴 */
.normallist{
  font-size: 18px;
  color: #aaaaaa;
  background-color: #ffffff;
  border-radius: 10px 10px 10px 10px;
  margin-left: 10px;
  margin-right: 10px;
  margin-top: 5px;
  margin-bottom: 5px;
  height: 48px;
}
.normallist:hover{
  font-size: 18px;
  color: white;
  background-color: #9a55f5;
  border-radius: 10px 10px 10px 10px;
  margin-left: 10px;
  margin-right: 10px;
  margin-top: 5px;
  margin-bottom: 5px;
  height: 48px;
}

.normaltext{
  color:#aaaaaa !important;
}
.normaltext:hover{
  color:white !important;
}

/* 사이드메뉴 선택 라운드 */
.btn_round{
  white-space: normal;
  font-size: 17px !important;
  font-family: 'Pretendard' !important;
  font-style: normal !important;
  font-weight: 600 !important;
  color: #333333 ;
}
.btn_select_round{
  white-space: normal;
  font-size: 17px !important;
  font-family: 'Pretendard' !important;
  font-style: normal !important;
  font-weight: 600 !important;
}

.selectlist{
  font-size: 18px;
  color: white;
  background-color: #6e00fa;
  border-radius: 10px 10px 10px 10px;
  margin-left: 10px;
  margin-right: 10px;
  margin-top: 5px;
  margin-bottom: 5px;
  height: 48px;
}

.search_btn_freesize {
  color: #ffffff !important;
  background-color: #000000 !important;
  border: thin solid #ffffff !important;
  border-radius: 0px !important;
  font-size: 12px !important;
  height: 43px !important;
  width: 98% !important;
  text-align: center !important;
  box-shadow: 2px 2px 5px #00000030 !important;
}


/* 팝업 타이틀 */
.dialog_title {
  color: #0A0A0A !important;
  font-size: 20px !important;
  font-weight: bold !important;
}

/* 팝업  클로즈 버튼 */
.dialog_close_btn {
  color: #e5e5e5 !important;
  background-color: #ffffff !important;
  border-color:#e5e5e5 !important; 
  border-style:solid !important; 
  border-width:1px 1px 1px 1px !important;
}

/* 팝업 하단 버튼 */
.dialog_cancel_btn{
    color: #000000 !important;
    background-color: #ffffff !important;
    font-size: 16px !important;
    border-radius: 0px !important;
    height: 51px !important;
    width:100% !important;
    border: black 2px solid;

}

.dialog_btn {
    color: #ffffff !important;
    background-color: #000000 !important;
    font-size: 16px !important;
    border-radius: 0px !important;
    height: 51px !important;
    width:100% !important;
}

/* 리모트 컨트롤 버튼 */
.remote_btn{
  color: #000000 !important;
  background-color: #ffffff !important;
  font-size: 16px !important;
  border-radius: 0px !important;
  height: 51px !important;
  width:100% !important;
  border: black 2px solid;
}


.paneloutline{
  border: solid 1px #808080;
}

/* 스크롤바 커스텀 디자인 */
.scrollBar::-webkit-scrollbar {
    width: 6px;  /* 스크롤바의 너비 */
}
.scrollBar::-webkit-scrollbar-thumb {
    height: 10%; /* 스크롤바의 길이 */
    background: #afafaf80; /* 스크롤바의 색상 */
    border-radius: 6px;
}
.scrollBar::-webkit-scrollbar-track {
    background: #ffffff80;  /*스크롤바 뒷 배경 색상*/
}

.barotitle{
  font-family: 'Lemon';
  font-style: normal;
  font-weight: 400;
  font-size: 32px;
  line-height: 42px;
  background: linear-gradient(90deg, #FF0000 0%, #6E00FA 78.48%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-fill-color: transparent;
}

.top_menu_text{
  font-family: 'Noto Sans KR';
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 26px;
  display: flex;
  align-items: center;
  color: rgb(0, 0, 0) !important;
}


.priceround{
  border: 1px solid #e6e6e6;
  border-radius: 5px;
  padding: 10px;
  width: 100%;
  max-width: 350px;
}

.pricetitle{
  border-radius: 8px;
  background-color: #7930ff;
  color: #ffffff;
  width: 80%;
  height: 50px;
  line-height: 50px;
  font-size: 20px;
  font-weight: bold;
  font-family: 'Noto Sans KR';
  text-align: center;
}

.pricevalue{
  font-size: 30px;
  font-weight: bold;
  font-family: 'Noto Sans KR';
  text-align: center;
  margin-top: 20px;
  margin-bottom: 20px;
}

.pricedesc{
  font-size: 20px;
  font-weight: bold;
  font-family: 'Noto Sans KR';
  text-align: center;
}

.priceline{
  height: 1px;
  width: 90%;
  background-color: #7930ff;
}

.pricetext{
  font-size: 15px;
  line-height: 30px;
  font-weight: bold;
  font-family: 'Noto Sans KR';
  text-align: left;
}

.pricebtn{
  width:80%;
  height: 40px;
  color:white !important;
  font-weight: bold;
  font-family: 'Noto Sans KR';
  font-size: 15px;
}


.h1_text{
  font-family: 'Noto Sans KR';
  font-style: normal;
  font-weight: 700;
  font-size: 80px;
  line-height: 116px;
  color: rgb(0, 0, 0) !important;
  white-space: nowrap;
}

.h1_text_mb{
  font-family: 'Noto Sans KR';
  font-style: normal;
  font-weight: 700;
  font-size: 32px;
  line-height: 42px;
  color: rgb(0, 0, 0) !important;
  white-space: nowrap;
}

.h2_text{
  font-family: 'Noto Sans KR';
  font-style: normal;
  font-weight: 700;
  font-size: 64px;
  line-height: 116px;
  color: rgb(0, 0, 0) !important;
  white-space: nowrap;
}

.h2_text_mb{
  font-family: 'Noto Sans KR';
  font-style: normal;
  font-weight: 700;
  font-size: 26px;
  line-height: 42px;
  color: rgb(0, 0, 0) !important;
  white-space: nowrap;
}

.h3_text{
  font-family: 'Noto Sans KR';
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 29px;
  color: rgb(0, 0, 0) !important;
  white-space: nowrap;
}

.h4_text{
  font-family: 'Noto Sans KR';
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 29px;
  color: #404040 !important;
  white-space: nowrap;
}

.img-hover-zoom {
  transition: transform 0.5s ease; /* 애니메이션 속도와 타입 설정 */
  display: inline-block; /* 이미지를 인라인 블록으로 설정 */
}
.img-hover-zoom:hover {
  transform: scale(1.1); /* 이미지 확대 비율 설정 */
}

.footer_text1{
  font-size:15px;
  color:#b0b8b8;
  
}
.footer_text2{
  font-size:13px;
  color:#ffffff;
}



.info_text{
  font-family: Inter;
  font-size: 12px;
  color: #303030
}

</style>
